// useTimer.js
import { useState, useEffect } from 'react';

export function useTimer(expirationTime, onExpire) {
  const [contagemRegressiva, setContagemRegressiva] = useState('');

  useEffect(() => {
    if (!expirationTime) return;

    const interval = setInterval(() => {
      const agora = new Date();
      const diff = new Date(expirationTime) - agora;

      if (diff <= 0) {
        clearInterval(interval);
        onExpire?.();
      } else {
        const minutos = Math.floor(diff / 60000);
        const segundos = Math.floor((diff % 60000) / 1000);
        setContagemRegressiva(`${String(minutos).padStart(2, '0')}:${String(segundos).padStart(2, '0')}`);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [expirationTime, onExpire]);

  return contagemRegressiva;
}
